import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import { compose } from 'recompose';
import { ui } from 'components';
import apiHOCs from 'components/apiHOCs';
import slide1 from 'assets/img/slide1.png';
import slide2 from 'assets/img/slide2.png';
import slide3 from 'assets/img/slide3.png';
import imageMan from 'assets/img/main_man.png';
import imageWoman from 'assets/img/main_woman.png';
import imageKid from 'assets/img/main_kid.png';

import 'assets/screens.scss';
import './style.scss';

const FrontScene = ({
  productsListApiHOC: {
    products,
  },
}) => (
	<div className="front-layout">
    <Slider
      speed={500}
      dots
      infinite
    >
      <img src={slide1} alt="Слайд 1" className="front-layout__slide" />
      <img src={slide2} alt="Слайд 2" className="front-layout__slide" />
      <img src={slide3} alt="Слайд 3" className="front-layout__slide" />
    </Slider>
    <div className="front-layout__categories">
      <ui.CategoryBlock link="catalog" img={imageMan} span="Мужское термобелье" />
      <ui.CategoryBlock link="catalog" img={imageWoman} span="Женское термобелье" />
      <ui.CategoryBlock link="catalog" img={imageKid} span="Детское термобелье" />
    </div>
    <div className="front-layout__hr" />
    <h1 className="front-layout__caption">Мы рекомендуем</h1>
    <div className="front-layout__products">
      {products.map(
        (product, i) => i < 3 ? <ui.ProductCard key={product.id} {...product} /> : null,
      )}
    </div>
	</div>
);

FrontScene.propTypes = {
  productsListApiHOC: PropTypes.shape({
    products: PropTypes.array,
  }).isRequired,
};

export default compose(
  apiHOCs.ProductsListApiHOC(),
)(FrontScene);



// WEBPACK FOOTER //
// ./src/scenes/FrontScene/index.js